import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryBrands = {
  async brands(parent, args, context, info) {
    let { lang = AppSettings.defaultLocale(), cdn = true } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.BRANDS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const brands = await client.fetch(
      groq`     
    array::unique(*[_type == "article" ].brand)
      `,
    )

    return brands?.filter((brand) => brand !== null).map((brand) => ({ name: brand })) || []
  },
}
